export default {
  mortgage_and_rent: "Rent or Mortgage Payments",
  vehicle_purchase_and_lease: "Car Payments",
  health_insurance: "Health Insurance",
  other_debt_payments: "Other Debt Payments & Obligations",
  savings: "Amount to Savings Each Period",
  life_and_personal_insurance: "Life & Other Personal Insurance",
  cash_contributions: "Charitable Giving",
  miscellaneous: "Miscellaneous",
  tobacco_and_smoking: "Miscellaneous",
  education: "Education and Childcare",
  reading: "Miscellaneous",
  personal_care: "Personal Care Products and Services",
  toys_and_hobbies: "Fun & Leisure",
  pets: "Pets",
  media_hardware_and_services: "Cable / Internet / Streaming",
  fees_and_admissions: "Fun & Leisure",
  medical_supplies: "Medical Spending",
  prescription_drugs: "Medical Spending",
  medical_services: "Medical Spending",
  public_and_other_transportation: "Transportation Fares",
  vehicle_insurance: "Car Insurance",
  vehicle_maintenance_and_repairs: "Car Maintenance",
  gasoline: "Gasoline & EV-Charging",
  clothing_items_and_services: "Clothing & Jewelry",
  furniture_and_appliances: "Home Appliances & Furniture",
  housekeeping_supplies: "Home Maintenance & Services",
  other_household_expenses: "Home Maintenance & Services",
  water_and_public_services: "Utilities - Other",
  telephone_services: "Phone Services",
  personal_services: "Education and Childcare",
  heating_fuels_other: "Utilities - Other",
  electricity: "Utilities - Power Bill",
  natural_gas: "Utilities - Other",
  other_lodging: "Fun & Leisure",
  home_maintenance_and_repairs: "Home Maintenance & Services",
  alcoholic_beverages: "Groceries",
  food_out: "Dining Out",
  food_home: "Groceries",
}
